import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Authentication = ({ userData, onUpdate, onFieldChange }) => {
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      onFieldChange("authentication", name, checked);
      if (name === "noEmail" && checked) {
        // Set username from sessionStorage or empty string
        const username = sessionStorage.getItem("username") || "";
        onFieldChange("authentication", "userName", username);
        onFieldChange("authentication", "confirmUserName", username);
      } else if (name === "noEmail" && !checked) {
        // Set username to email from userData or empty string
        const email = userData.email || "";
        onFieldChange("authentication", "userName", email);
        onFieldChange("authentication", "confirmUserName", email);
      }
    } else {
      onFieldChange("authentication", name, value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { userName, password, confirmUserName, confirmPassword, noEmail } =
      userData.authentication || {};

    if (!userName || !password) {
      toast.error("Username and Password are required.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        closeButton: true,
      });
      return;
    }

    if (userName !== confirmUserName) {
      toast.error("Usernames do not match.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        closeButton: true,
      });
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        closeButton: true,
      });
      return;
    }

    // Prepare data to update
    const updatedData = {
      ...userData,
      authentication: {
        ...userData.authentication,
        userName,
        password,
        noEmail,
        firstName: userData.first_name,
        lastName: userData.last_name,
      },
    };

    // Call onUpdate to submit changes to the server
    const success = await onUpdate(updatedData);
    if (success) {
      toast.success("Authentication details updated successfully!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        closeButton: true,
      });
    }
  };

  const Styles = `
    .title {
      margin-bottom: 20px;
    }
    .form-container {
      border: 1px solid #f8f9fa;
      border-top: 3px solid #004aad;
    }
    .form-group {
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }
    .loading {
      color: #004aad;
      margin-left: 10px;
    }
    .error {
      color: red;
      margin-left: 10px;
    }
    .user-info {
      margin: 10px;
      padding: 10px;
      background-color: #e9ecef;
      border-radius: 4px;
    }
  `;

  return (
    <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="row">
        <div
          className="col-md-2"
          style={{ borderRight: "1px solid #004aad" }}
        ></div>
        <div className="col-md-10">
          <style>{Styles}</style>
          <h1 className="title">Authentication</h1>

          {(userData.first_name || userData.last_name) && (
            <div className="user-info">
              <p>
                <strong>User:</strong> {userData.first_name}{" "}
                {userData.last_name}
              </p>
            </div>
          )}

          <div
            className="form-container"
            style={{
              border: "1px solid #f8f9fa",
              borderTop: "3px solid #004aad",
              backgroundColor: "#f8f9fa",
            }}
          >
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label
                  style={{
                    fontWeight: "bold",
                    marginLeft: "10px",
                  }}
                >
                  ID:
                </label>
                <input
                  type="text"
                  name="id"
                  value={userData.userId || ""}
                  style={{
                    marginRight: "40%",
                    width: "30%",
                    padding: "8px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                  disabled={true}
                />
              </div>
              <div className="form-group">
                <label
                  style={{
                    fontWeight: "bold",
                    marginLeft: "10px",
                  }}
                >
                  No email?
                </label>
                <input
                  type="checkbox"
                  name="noEmail"
                  checked={userData.authentication?.noEmail || false}
                  onChange={handleInputChange}
                  style={{
                    marginRight: "63.5%",
                    width: "10%",
                  }}
                />
              </div>
              <div className="form-group">
                <label
                  style={{
                    fontWeight: "bold",
                    marginLeft: "10px",
                  }}
                >
                  {userData.authentication?.noEmail ? "Username" : "Email"}:
                </label>
                <input
                  type="text"
                  name="userName"
                  value={userData.authentication?.userName || ""}
                  onChange={handleInputChange}
                  style={{
                    marginRight: "40%",
                    width: "30%",
                    padding: "8px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                  disabled={userData.authentication?.noEmail}
                />
              </div>
              <div className="form-group">
                <label
                  style={{
                    fontWeight: "bold",
                    marginLeft: "10px",
                  }}
                >
                  Confirm {userData.authentication?.noEmail ? "Username" : "Email"}:
                </label>
                <input
                  type="text"
                  name="confirmUserName"
                  value={userData.authentication?.confirmUserName || ""}
                  onChange={handleInputChange}
                  style={{
                    marginRight: "40%",
                    width: "30%",
                    padding: "8px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                  disabled={userData.authentication?.noEmail}
                />
              </div>
              <div className="form-group">
                <label
                  style={{
                    fontWeight: "bold",
                    marginLeft: "10px",
                  }}
                >
                  Current Password:
                </label>
                <input
                  type="text"
                  name="currentPasswordMask"
                  value="********"
                  style={{
                    marginRight: "40%",
                    width: "30%",
                    padding: "8px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                  disabled={true}
                />
              </div>
              <div className="form-group">
                <label
                  style={{
                    fontWeight: "bold",
                    marginLeft: "10px",
                  }}
                >
                  New Password:
                </label>
                <input
                  type="password"
                  name="password"
                  value={userData.authentication?.password || ""}
                  onChange={handleInputChange}
                  style={{
                    marginRight: "40%",
                    width: "30%",
                    padding: "8px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                  placeholder="Enter new password"
                />
              </div>
              <div className="form-group">
                <label
                  style={{
                    fontWeight: "bold",
                    marginLeft: "10px",
                  }}
                >
                  Confirm Password:
                </label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={userData.authentication?.confirmPassword || ""}
                  onChange={handleInputChange}
                  style={{
                    marginRight: "40%",
                    width: "30%",
                    padding: "8px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                  placeholder="Confirm new password"
                />
              </div>
              <div className="form-group">
                <button
                  type="submit"
                  style={{
                    marginLeft: "10px",
                    padding: "8px 16px",
                    backgroundColor: "#004aad",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Authentication;